import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { Eye, EyeOff, AlertCircle } from 'lucide-react';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!username || !password) {
      setError('Username dan password harus diisi');
      return;
    }

    setLoading(true);
    try {
      await login(username, password);
      navigate('/');
    } catch (err) {
      const msg = err?.response?.data?.error;
      if (msg) setError(msg);
      else if (err.message) setError(err.message);
      else setError('Gagal masuk. Periksa koneksi server.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-bg">
        <div className="login-bg-shapes">
          <div className="shape shape-1" />
          <div className="shape shape-2" />
          <div className="shape shape-3" />
        </div>
      </div>

      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <Link to="/" style={{ textDecoration: 'none' }} className="login-logo-link">
              <img src="/logo-synexa.png?v=2" alt="LayananSynexa" style={{ width: 230, height: 'auto', marginBottom: 12, display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />
              <h1>Layanan<span>Synexa</span></h1>
              <p className="login-subtitle">Fleet Management System</p>
            </Link>
            <p className="login-desc">Masuk untuk mengelola armada kendaraan</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            {error && (
              <div className="login-error">
                <AlertCircle size={16} />
                <span>{error}</span>
              </div>
            )}

            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                id="username"
                type="text"
                placeholder="Masukkan username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoFocus
                autoComplete="username"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div className="password-input">
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Masukkan password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex={-1}
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="login-btn"
              disabled={loading}
            >
              {loading ? (
                <span className="login-btn-loading">
                  <span className="spinner" />
                  Memasuki sistem...
                </span>
              ) : (
                'Masuk ke Dashboard'
              )}
            </button>
          </form>

          <div className="login-footer">
            <p>&copy; 2026 LayananSynexa. All rights reserved.</p>
            <p style={{ marginTop: 8, fontSize: '0.75rem' }}>
              <a
                href="/mobile-web/"
                style={{ color: 'var(--gray-400)', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 4 }}
                onClick={() => { document.cookie = 'desktop_mode=;path=/;max-age=0'; }}
              >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
                  <line x1="12" y1="18" x2="12.01" y2="18"/>
                </svg>
                Versi Mobile
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
